import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'compass-common.components-table-empty-state.heading',
		defaultMessage: 'No Compass components are linked to your project',
		description:
			'Heading text displayed when there are no Compass components associated with the current project.',
	},
	noComponentsHeading: {
		id: 'compass-common.components-table-empty-state.no-components-heading',
		defaultMessage: "You don't have any software components in Compass",
		description:
			'Heading text displayed when there are no Compass components associated with the current project.',
	},
	noLinkedComponentsHeading: {
		id: 'compass-common.components-table-empty-state.no-linked-components-heading',
		defaultMessage:
			'{componentCount, plural, one {You have # software component in Compass, but it is not linked to an issue} other {You have # software components in Compass, but none are linked to issues}}',
		description:
			'Heading text displayed when there are no Compass components associated with the current project.',
	},
	body: {
		id: 'compass-common.components-table-empty-state.body',
		defaultMessage:
			"Create a component in Compass, then add it to an issue's <b>Components</b> field. The component and its related information will appear here.",
		description:
			'Body text displayed when there are no Compass components associated with the current project.',
	},
	noComponentsBody: {
		id: 'compass-common.components-table-empty-state.no-components-body',
		defaultMessage:
			'Issues can be linked to Compass software components, so you can track and manage the work on your software architecture.',
		description:
			'Body text displayed when there are no Compass components associated with the current project.',
	},
	noLinkedComponentsBody: {
		id: 'compass-common.components-table-empty-state.no-linked-components-body',
		defaultMessage:
			'Add a component to an issue’s <b>Components</b> field. Both will appear here, so you can track the work on your software architecture.',
		description:
			'Body text displayed when there are no Compass components associated with the current project.',
	},
	gotoIssues: {
		id: 'compass-common.components-table-empty-state.goto-issues',
		defaultMessage: 'Go to issues',
		description:
			"Go to issues link text. Clicking this link will navigate to the site's issues page.",
	},
	learnMore: {
		id: 'compass-common.components-table-empty-state.learn-more',
		defaultMessage: 'Learn more',
		description:
			'Learn more link text where users can get more information about Compass components.',
	},
});
